/** Hindi: the job between two phones: questions, details, the price plan, statuses, offers, signing, notes. */
export const job = {
    "question.problem": "ठीक-ठीक क्या ख़राब है?",
    "question.rooms": "कितने कमरे हैं, और कौन-कौन से काम करने हैं?",
    "question.area_sqft": "लगभग कितने वर्ग फ़ुट, अंदर या बाहर?",
    "question.people": "घर में कितने लोग रहते हैं?",
    "question.meals": "किस-किस वक़्त का खाना बनाना है? (नाश्ता, दोपहर, रात)",
    "question.pets": "क्या घर में कोई पालतू जानवर है?",
    "question.route": "कहाँ से कहाँ तक, और कितनी देर के लिए?",
    "question.labour_only": "क्या पेंट आप ख़ुद ख़रीदेंगे?",
    "question.frequency": "कितनी बार आना है: रोज़, एक दिन छोड़कर, या हफ़्ते में एक बार?",
    "question.hours": "दिन में कितने घंटे?",
    "question.coats": "पेंट के कितने कोट?",
    "detail.problem": "समस्या",
    "detail.rooms": "कमरे",
    "detail.area_sqft": "जगह का साइज़",
    "detail.people": "लोग",
    "detail.meals": "खाना",
    "detail.pets": "पालतू जानवर",
    "detail.route": "रास्ता",
    "detail.labour_only": "पेंट आप ख़रीदेंगे",
    "detail.frequency": "कितनी बार",
    "detail.hours": "दिन में घंटे",
    "detail.coats": "पेंट के कोट",
    "reason.band": "यहाँ इस काम का चलता रेट {low}–{high} है।",
    "reason.scope": "{item}: {percent}% ज़्यादा।",
    "reason.history": "पहले इस काम के लिए आपको लगभग {median} मिलते थे ({count} काम)।",
    "reason.floor": "आपका अपना सबसे कम दाम {floor} है।",
    "reason.plan": "{opening} से शुरू करेंगे, {limit} से नीचे नहीं जाएँगे।",
    "status.draft": "भेजा जा रहा है",
    "status.sent": "पूछा गया",
    "status.clarifying": "सवाल पूछा गया",
    "status.responded": "जवाब दिया गया",
    "status.negotiating": "एजेंट मोलभाव कर रहे हैं",
    "status.confirming": "दस्तख़त का इंतज़ार",
    "status.agreed": "तय हो गया",
    "status.in_progress": "रास्ते में",
    "status.delivered": "काम पूरा",
    "status.revision": "ठीक किया जा रहा है",
    "status.closed": "बंद",
    "status.declined": "मना कर दिया",
    "status.expired": "समय निकल गया",
    "status.cancelled": "रद्द",
    "cancel.no_match": "इस तरह का काम या यह इलाक़ा इनकी लिस्ट में नहीं",
    "cancel.no_deal": "दोनों की सीमा में कोई दाम नहीं बना",
    "cancel.declined_by_owner": "मना कर दिया गया",
    "cancel.taken": "किसी और कामगार से तय हो गया",
    "cancel.other": "रद्द",
    "job.customer": "ग्राहक",
    "job.worker": "कामगार",
    "job.signed": "दस्तख़त: {price}",
    "job.both_signed": "दोनों ने दस्तख़त किए",
    "job.their_signature": "उनके दस्तख़त का इंतज़ार",
    "job.elsewhere": "आपका दूसरा फ़ोन इस काम का जवाब दे रहा है। आगे देखने के लिए वहीं GigSync खोलें।",
    "job.contact": "संपर्क, दोनों के दस्तख़त के बाद ही",
    "job.asks": "कामगार का सवाल: {question}",
    "job.send_answers": "जवाब भेजें",
    "job.reached": "आपका एजेंट {price} पर पहुँचा।",
    "job.sign": "{price} पर सौदा पक्का करें",
    "job.decline": "मना करें",
    "job.start_work": "पहुँचकर काम शुरू करें",
    "job.mark_done": "काम पूरा कर दिया",
    "job.ask_payment": "पैसे माँगें",
    "lang.en": "अंग्रेज़ी",
    "lang.hi": "हिन्दी",
    "lang.kn": "कन्नड़",
    "flag.yes": "हाँ",
    "flag.no": "नहीं",
    "plan.title": "आपके एजेंट का प्लान, सिर्फ़ आपके फ़ोन पर",
    "approve.title": "एजेंट दाम बताए, उससे पहले देख लें",
    "approve.flagged": "आपने ये पहले देखना चाहा था: {items}।",
    "approve.yes": "{price} से शुरू करें",
    "approve.no": "यह काम नहीं लेना",
    "trade.electrician": "इलेक्ट्रीशियन",
    "trade.plumber": "प्लंबर",
    "trade.maid": "घरेलू कामगार",
    "trade.carpenter": "बढ़ई",
    "trade.ac_technician": "एसी मैकेनिक",
    "trade.painter": "पेंटर",
    "trade.cook": "कुक",
    "trade.driver": "ड्राइवर",
    "area.indiranagar": "इंदिरानगर",
    "area.koramangala": "कोरमंगला",
    "area.hsr_layout": "एचएसआर लेआउट",
    "area.jayanagar": "जयनगर",
    "area.whitefield": "व्हाइटफ़ील्ड",
    "city.bengaluru": "बेंगलुरु",
    "update.on_my_way": "मैं रास्ते में हूँ",
    "update.started": "काम शुरू कर दिया",
    "update.done": "काम पूरा हो गया",
    "update.delayed": "थोड़ी देर हो रही है",
    "pay.thread.requested": "माँगा गया",
    "pay.thread.paid": "भुगतान किया",
    "pay.thread.confirmed": "पक्का",
    "pay.thread.disputed": "विवाद में",
    "job.payment": "भुगतान {price}: {status}",
    "job.utr": "यूपीआई रेफ़ {utr}",
    "job.customer_paid": "ग्राहक के मुताबिक़ उन्होंने {price} दे दिए हैं।",
    "job.money_received": "पैसे मिल गए",
    "job.not_received": "नहीं मिले",
    "job.pay_by_upi": "{price} यूपीआई से दें",
    "job.open_upi": "यूपीआई ऐप में खोलें",
    "job.utr_placeholder": "12 अंकों का यूपीआई रेफ़रेंस",
    "job.paid": "मैंने पैसे दे दिए",
    "job.review_placeholder": "काम कैसा रहा?",
    "job.send_review": "राय भेजें",
    "job.note_placeholder": "ग्राहक के लिए छोटा संदेश",
    "job.send_note": "संदेश भेजें",
};
//# sourceMappingURL=job.js.map